import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { convertLegacyEntityCardExtension } from '@backstage/plugin-catalog-react/alpha';
import {
  EntityAmazonEcsServicesContent,
  isAmazonEcsServiceAvailable,
} from '@aws/amazon-ecs-plugin-for-backstage';

/**
 * Amazon ECS entity card (AWS Labs plugin suite, Wave 4 — see
 * docs/plugins/README.md + docs/operations.md → "AWS Labs plugin suite").
 *
 * `@aws/amazon-ecs-plugin-for-backstage` has no native `/alpha` export (it
 * predates the new frontend system), so its legacy
 * `EntityAmazonEcsServicesContent` component is bridged in via
 * `convertLegacyEntityCardExtension` rather than a hand-rolled
 * EntityCardBlueprint — same official bridge Backstage ships for exactly
 * this case. The plugin's own `isAmazonEcsServiceAvailable` guard controls
 * visibility: the card is absent (not an empty error state) on any entity
 * missing the `aws.amazon.com/amazon-ecs-service-{tags,arn}` annotation.
 *
 * Shows empty/permission-denied until DevOps attaches the ecs:Describe*
 * IAM actions to devhub-prod-task-role — expected, not a bug.
 */
const awsEcsEntityCard = convertLegacyEntityCardExtension(
  EntityAmazonEcsServicesContent,
  {
    name: 'aws-ecs',
    filter: isAmazonEcsServiceAvailable,
  },
);

export const awsEcsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [awsEcsEntityCard],
});
